export default {
  'get-list': {
    method: 'post',
    url: '/partner/order/request/list'
  },
  add: {
    method: 'post',
    url: '/partner/order/request'
  },
  delete: {
    method: 'delete',
    url: '/partner/order/request'
  },
  update: {
    method: 'put',
    url: '/partner/order/request/ID'
  },
  changeStatus: {
    method: 'put',
    url: '/partner/order/request/status'
  },
  select: {
    method: 'get',
    url: '/partner/order/request/find?key=KEY'
  }
}
